if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      this.submitBtn = this.querySelector('[name="add"]');

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      const mediasValue = String(formData.get('properties[Medias]') || '').trim().toLowerCase();
      const mediasSelected = mediasValue === 'sí' || mediasValue === 'si';

      const mainVariantId = Number(formData.get('id'));
      const quantity = Number(formData.get('quantity') || 1);
      const MEDIAS_VARIANT_ID = 53695510544711;

      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      const extractPropertiesFromFormData = (fd) => {
        const props = {};

        for (const [key, value] of fd.entries()) {
          if (key.startsWith('properties[') && key.endsWith(']')) {
            const cleanKey = key.replace('properties[', '').replace(']', '');
            if (String(value).trim() !== '') {
              props[cleanKey] = value;
            }
          }
        }

        return props;
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        let data;
        let addedVariantId = mainVariantId;

        if (mediasSelected) {
          const mediasGroup = `medias_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
          const mainProperties = extractPropertiesFromFormData(formData);

          mainProperties.Medias = 'Sí';
          mainProperties._medias_group = mediasGroup;

          const payload = {
            items: [
              {
                id: mainVariantId,
                quantity,
                properties: mainProperties
              },
              {
                id: MEDIAS_VARIANT_ID,
                quantity,
                properties: {
                  _is_medias_addon: 'true',
                  _medias_group: mediasGroup
                }
              }
            ]
          };

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(payload)
          });

          data = await response.json();

          let error = typeof data.description === 'string' ? data.description : data.message;
          if (data.errors && typeof data.errors === 'object') {
            error = Object.entries(data.errors).map((item) => item[1].join(', '));
          }

          if (data.status) this.setErrorMsgState(error);
          if (!response.ok) throw new Error(error || response.status);

          // Refresh cart icon bubble manually
          const bubbleResponse = await fetch(`${window.location.pathname}?sections=cart-icon-bubble`);
          if (bubbleResponse.ok) {
            const bubbleData = await bubbleResponse.json();
            ProductForm.updateCartIcon({ sections: bubbleData });
          }

          // Quick add support
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          // Refresh and open cart drawer
          if (this.cartDrawer && theme.settings.afterAtc === 'drawer') {
            await this.cartDrawer.refresh(true);
            this.cartDrawer.open();
          } else if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
              if (cartItems.dataset.empty === 'true') {
                window.location.reload();
              } else {
                cartItems.refresh();
              }
            }
          }
        } else {
          const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
          data = await response.json();

          let error = typeof data.description === 'string' ? data.description : data.message;
          if (data.errors && typeof data.errors === 'object') {
            error = Object.entries(data.errors).map((item) => item[1].join(', '));
          }

          if (data.status) this.setErrorMsgState(error);
          if (!response.ok) throw new Error(response.status);

          if (theme.settings.afterAtc === 'page') {
            setTimeout(() => {
              window.location.href = theme.routes.cart;
            }, 300);
          } else {
            ProductForm.updateCartIcon(data);

            const quickAddDrawer = this.closest('quick-add-drawer');
            if (quickAddDrawer) quickAddDrawer.addedToCart();

            setTimeout(() => {
              if (this.cartDrawer) {
                this.cartDrawer.renderContents(
                  data,
                  !quickAddDrawer && theme.settings.afterAtc === 'drawer'
                );
              } else if (window.location.pathname === theme.routes.cart) {
                const cartItems = document.querySelector('cart-items');
                if (cartItems) {
                  if (cartItems.dataset.empty === 'true') {
                    window.location.reload();
                  } else {
                    cartItems.refresh();
                  }
                }
              }
            }, 700);
          }

          addedVariantId = data.variant_id;
        }

        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === addedVariantId
        )[0];

        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              variantId: addedVariantId,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: itemInOldCart.quantity + quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              variantId: addedVariantId
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        this.submitBtn.disabled = false;

        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && response.sections && response.sections['cart-icon-bubble']) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}